/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { NextUIProvider } from '@nextui-org/react';
import { Provider, useDispatch } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import toast, { Toaster } from 'react-hot-toast';
import Router from './router';
import { setMomentLocale } from './utils';
import { persistor, store } from './store';
import { AuthService } from './services';
import { SocketProvider } from './context/socket';
import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

function Container() {
  const dispatch = useDispatch();
  const toastStyles = { padding: 12, color: '#3F3F46' };

  useEffect(() => {
    setMomentLocale();
    const getUser = async () => {
      const user = store.getState()?.user;
      if (!user) return;

      const res = await AuthService.checkUser({ user_id: user?.id });
      if (res.user) {
        dispatch({ type: 'SET_USER', payload: res.user });
      } else {
        toast.error("Lo sentimos, su usuario ha sido eliminado");
        dispatch({ type: 'SET_USER', payload: null });
      }
    }
    getUser();

  }, []);

  return (
    <SocketProvider>
      <NextUIProvider>
        <Router />
        <Toaster position="bottom-center" toastOptions={{ style: toastStyles }} />
      </NextUIProvider>
    </SocketProvider>
  );
}


export const App = () => {

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Container />
      </PersistGate>
    </Provider>
  )
}

export default App;
